import { useQuery } from '@apollo/client'
import { Cart } from '@commerce/types'
import {
  getCurrencyCountryCode,
  getLanguage,
  getProductQuery,
  normalizeProduct,
} from '@commerce/utils'
import UpsellItem from '@components/common/UpsellSideBar/UpsellItem/UpsellItem'
import { ChevronLeft } from '@components/icons'
import {
  checkUpsellProductExistsByVariant,
  getUpsellProdutsByCart,
} from '@lib/cart'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import Slider from 'react-slick'

interface Props {
  cart: Cart.Cart
}

const CartUpsellItems = ({ cart }: Props) => {
  const { locale } = useRouter()
  const sliderRef = useRef<any>(null)
  const upsellProducts = getUpsellProdutsByCart(cart)
  const { t } = useTranslation('cart')
  const { data: prepCoatData } = useQuery(getProductQuery, {
    variables: {
      slug: 'lime-wash-prep-coat',
      country: getCurrencyCountryCode(locale),
      language: getLanguage(locale),
    },
    context: { locale },
    skip: !upsellProducts.includes('lime-wash-prep-coat'),
  })
  const prepCoatProduct = prepCoatData?.productByHandle
    ? normalizeProduct(prepCoatData.productByHandle)
    : null

  let upsellItems: { handle: string; variantId?: string }[] = []
  upsellProducts.forEach((handle) => {
    if (handle === 'lime-wash-prep-coat' && prepCoatProduct) {
      prepCoatProduct.variants.forEach((variant) => {
        const exists = checkUpsellProductExistsByVariant(
          cart,
          String(variant.id)
        )
        if (!exists || exists.length === 0) {
          upsellItems.push({ handle, variantId: String(variant.id) })
        }
      })
    } else {
      upsellItems.push({ handle })
    }
  })

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: upsellItems.length > 1 ? 1.55 : 1,
    slidesToScroll: 1,
  }
  if (upsellItems.length === 0) return null
  return (
    <>
      <div className="relative flex items-center justify-between bg-ui-lightest-grey px-5 py-4">
        <div className="body-2-bold capitalize">{t('recommended-for-you')}</div>
        <div className="absolute right-2 flex">
          <button
            className="flex h-11 w-11 items-center justify-center"
            onClick={() => sliderRef.current?.slickPrev()}
          >
            <ChevronLeft className="h-4 w-full" />
          </button>
          <button
            className="flex h-11 w-11 items-center justify-center"
            onClick={() => sliderRef.current?.slickNext()}
          >
            <ChevronLeft className="h-4 w-full rotate-180 transform" />
          </button>
        </div>
      </div>

      <Slider ref={sliderRef} {...settings} className="px-5 pt-4">
        {upsellItems.map((item, index) => (
          <UpsellItem
            handle={item.handle}
            variantId={item.variantId}
            key={`${item.handle}-${item.variantId || 'default'}-cart-${locale}`}
            index={index}
            cart={cart}
            cardStyle="cart"
          />
        ))}
      </Slider>
    </>
  )
}

export default CartUpsellItems
